<template>
    <img :src="adItem.imgUrl" :alt="adItem.name" :style="{cursor: adItem.adUrl ? 'pointer' : 'default'}" @click="onAdClick()" />
    <!--<span>-->
        <!--<a class="ad-item" :href="adUrl" @click="onAdClick()"><img :src="adItem.imgUrl" alt=""></a>-->
    <!--</span>-->
</template>

<script>
    import { mapState, mapGetters, mapMutations, mapActions } from 'vuex'
    export default {
        props:['type'],
        data () {
            return {

            }
        },
        computed: {
            ...mapGetters('ad', ['getAdItem']),
            adItem: function () {
                return this.getAdItem(this.type)[0] || {};
            }
        },
        async created () {
            await this.getItemByTypeKey({ type: this.type });
            this.$emit('finished', this.adItem);
        },
        methods: {
            ...mapActions('ad', ['getItemByTypeKey', 'addAdClickCount']),
            onAdClick() {
                let url = this.adItem.adUrl || '';
                if (!url) return;
                // 外链打开新窗口
                if (/^https?/.test(url)) {
                    window.open(url);
                } else {
                    this.$router.push(url);
                }
                this.addAdClickCount({id: this.adItem._id});
            }
        }
    }
</script>

<style lang="scss">
.ad-item {
    display: inline-block;
}
</style>



// WEBPACK FOOTER //
// app/view/index/components/Ad.vue